import React from "react";
import { useNavigate, Link } from 'react-router-dom';
import Header from "../Component/Header";
import AdminHeader from "../Component/AdminHeader";
import Footer from "../Component/Footer";
import SubMenu from "../Component/SubMenu";
import { useContext } from 'react';
import { ArgContext } from '../../Context/ArgProvider';

import mainBg from "../../assets/img/bg-esg-04.jpg";
function SafetyMgmt() {
	// 화면 이동을 위한 네비게이터 설정
	const navigate = useNavigate();

	// 일반 또는 관리자 header 설정
	const { argInfo } = useContext(ArgContext);
	const isAdmin = argInfo?.role === 'admin';

    return (<>
	<main className="page-wrapper">
		{isAdmin ? <AdminHeader /> : <Header />}
		
      {/* <!-- 메인 미이지 + 슬로건 --> */}
			<section className="sub-bannerWrap comOverview-banner" style={{backgroundImage: `url(`+mainBg+`)`}} >
					<div className="textBox">
						<h2>안전보건경영</h2>
						<p>위피아는 지속가능한 경영을 위해 사회적 역할과 책임을 다하고 신뢰받는 기업이 되기 위해 노력합니다.</p>
					</div>
					<SubMenu />
			</section>

			<section className="safety-mgmt">
				<div className="container-auto sec-mt title-box">
					<h3 className="sub-title">안전보건경영 방침</h3>
						<p className="sub-text">
							위피아는 “임직원 및 협력사 직원의 건강과 공동체 안전”을 최우선 가치로 생각하며, 안전보건 성과의 지속적인 개선을 통해 안전하고 건강한 일터를 조성한다.
						</p>
				</div>
				<div className="bg-blue sec-py">
					<div className="container-auto">
						<ul className="enviro-list">
							<li>
								<p className="num">01</p>
								<p className="text">위피아는 안전보건 경영 의지를 지속적으로 표명하고, 임직원 및 협력사 직원은 이를 함께 성실하게 이행한다.</p>
							</li>
							<li>
								<p className="num">02</p>
								<p className="text">위피아는 안전보건에 관한 법규 및 이해관계자의 요구사항을 준수하고 경영활동 시 책임과 의무를 다한다.</p>
							</li>
							<li>
								<p className="num">03</p>
								<p className="text">위피아는 유해·위험 요인을 발굴하고 우선순위에 따라 지속적인 개선노력을 기울이며, 필요한 자원이 적기에 제공되도록 최선을 다한다.</p>
							</li>
							<li>
								<p className="num">04</p>
								<p className="text">위피아는 임직원 및 협력사 직원 등 이해관계자의 안전과 보건의 유지·증진 및 사고예방을 위하여 적극적 소통, 자율적 협의 및 참여 환경을 적극적으로 보장·조성한다.</p>
							</li>
							<li>
								<p className="num">05</p>
								<p className="text">위피아는 지속적인 교육훈련과 학습을 제공하여 안전의식을 제고하고 안전이 내재화된 조직문화를 만든다.</p>
							</li>
						</ul>
						<div className="signWrap">
							<p className="ceo">㈜위피아 대표이사 김용연 <span className="sign">대표이사 사인</span></p>
						</div>
					</div>
				</div>
			</section>

			{/* 안전보건 목표 */}
			<section className="container-auto sec-my">
				<p className="m-safetyList-title">안전보건 목표</p>
				<ul className="safety-list">
					<li>
						<p className="title">안전보건 개선</p>
						<p className="text">경영진은 사업장의 안전보건 활동을 위해 정기적으로 점검하며 임직원의 의견을 청취하고 개선한다.</p>
					</li>
					<li className="sec-title">안전보건 목표</li>
					<li>
						<p className="title">안전보건 활동</p>
						<p className="text">임직원은 규정된 안전보건 활동에 주도적으로 참여하고 실행한다.</p>
					</li>
					<li>
						<p className="title">산업재해 예방</p>
						<p className="text">산업재해를 예방하기 위하여 연1회 예산을 수립하고, 연말1회 집행 내역을 보고한다.</p>
					</li>
					<li>
						<p className="title">유해·위험 요인</p>
						<p className="text">유해·위험 요인에 대한 사전발굴 및 개선 절차 마련, 반기1회 이행점검을 한다.</p>
					</li>
					<li>
						<p className="title">안전보건 경영성과</p>
						<p className="text">연1회 정기적으로 안전보건 경영성과를 평가하여 경영진에게 보고한다.</p>
					</li>
				</ul>
			</section>
		</main>
	<Footer />


        </>
    )
}

export default SafetyMgmt;